import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { CODE_LISTS } from 'constants/enums'
import { codeLists as codeListsApi } from 'redux/modules/api'

function decorator(lists = [], config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api }) => ({
        codeLists: api.codeLists
      }),
      { ...codeListsApi }
    )
    class CodeLists extends Component {
      static propTypes = {
        codeLists: PropTypes.object.isRequired,
        getLists: PropTypes.func.isRequired,
        getListById: PropTypes.func.isRequired,
        getPublicLists: PropTypes.func.isRequired
      }

      componentDidMount() {
        const { codeLists } = this.props

        let listsToDownload = []

        if (lists.length > 0) {
          for (const listItem of lists) {
            listsToDownload = listsToDownload.concat(
              CODE_LISTS.list
                .filter(
                  item =>
                    item.label === listItem &&
                    (codeLists[listItem] && !codeLists[listItem].loaded)
                )
                .map(item => item.value)
            )
          }
        }

        if (listsToDownload.length > 0) {
          this.handleListDownload(listsToDownload.join(','))
        }

        config.id && this.handleIdDownload(config.id)
      }

      handleListDownload = listsToDownload => {
        !config.public && this.props.getLists(listsToDownload)
        config.public && this.props.getPublicLists(listsToDownload)
      }

      handleDownloadById = idToDownload => {
        this.props.getListById(idToDownload)
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            fetchCodeListById={this.handleDownloadById}
          />
        )
      }
    }
    return CodeLists
  }
}

export default decorator
